import { motion } from "framer-motion";
import { Award, BookOpen, Users, HeartHandshake } from "lucide-react";

const items = [
  {
    icon: Award,
    title: "Esperienza clinica",
    text: "Oltre quindici anni di attività ematologica in un centro di riferimento nazionale, con casistica ampia su patologie benigne e oncoematologiche.",
  },
  {
    icon: BookOpen,
    title: "Attività scientifica",
    text: "Partecipazione a studi clinici, aggiornamento continuo e coinvolgimento in progetti di ricerca in ambito ematologico.",
  },
  {
    icon: Users,
    title: "Approccio multidisciplinare",
    text: "Collaborazione con radiologi, patologi, oncologi e medici di famiglia per un percorso di cura integrato e coordinato.",
  },
  {
    icon: HeartHandshake,
    title: "Centralità del paziente",
    text: "Tempi di visita adeguati, comunicazione chiara e piano terapeutico costruito attorno alla persona, alla sua storia e alle sue priorità.",
  },
];

export default function PercheAffidarsi() {
  return (
    <section
      id="perche-affidarsi"
      data-testid="perche-section"
      className="py-24 md:py-32 bg-[#F9F8F6] border-b border-[#E5E1D8]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow">Perché affidarsi</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
              Quattro <span className="italic text-[#8A6D56]">valori</span> alla base della cura.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base text-[#5C635E] leading-relaxed">
            Un metodo clinico che unisce competenza specialistica, attenzione alla ricerca
            e centralità del rapporto con il paziente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E1D8] border border-[#E5E1D8] rounded-2xl overflow-hidden">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.article
                key={it.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`perche-card-${i}`}
                className="bg-white p-8 md:p-10 flex flex-col"
              >
                <Icon
                  className="w-6 h-6 text-[#8A6D56]"
                  strokeWidth={1.5}
                  aria-hidden
                />
                <h3 className="font-serif-display text-2xl md:text-[26px] leading-tight mt-8 text-[#1A1D1A]">
                  {it.title}
                </h3>
                <p className="text-[14px] text-[#5C635E] leading-relaxed mt-4">
                  {it.text}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
